import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import IPatientMetadata from '../../../app/_interfaces/IPatientMetadata';
import IMetadata from '../../../app/_interfaces/IMetadata';

@Injectable({
  providedIn: 'root',
})
export class PatientsMetadataService {
  public allTMetadata$: Subject<IPatientMetadata[]>;

  constructor(public http: HttpClient) {
    this.allTMetadata$ = new Subject();
  }

  getAll(customers_id: number) {
    return this.http
      .get<IPatientMetadata[]>(
        `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/metadata-patients`
      )
      .subscribe((patientsMetada: IPatientMetadata[]) => {
        this.allTMetadata$.next(patientsMetada);
      });
  }

  get(customers_id: number, id: number) {
    return this.http.get<IPatientMetadata[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/metadata-patients/${id}`
    );
  }

  create(customers_id: number, patientMetadata: IMetadata) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/metadata-patients/`,
      patientMetadata
    );
  }

  update(customers_id: number, patientMetadata: IPatientMetadata) {
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/metadata-patients/${patientMetadata.id}`,
      patientMetadata
    );
  }

  remove(customers_id: number, patientMetadata: IPatientMetadata) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/metadata-patients/${patientMetadata.id}`
    );
  }
}
